import React from 'react';
import classes from '../../bidAnalysisTemplate.module.scss';

interface MarketShareItem {
  vendor: string;
  share: number;
  volume?: number;
}

interface MarketShareChartProps {
  marketShareByVolume: MarketShareItem[];
  selectedCompany: string | null;
  onCompanyClick: (vendor: string) => void;
  isLoading?: boolean;
}

export const MarketShareChart: React.FC<MarketShareChartProps> = ({
  marketShareByVolume,
  selectedCompany,
  onCompanyClick,
  isLoading = false,
}) => {
  const getBarColor = (index: number) => {
    const colors = ['#10b981', '#22c55e', '#4ade80', '#86efac'];
    return colors[index] || colors[colors.length - 1];
  };

  return (
    <div className={classes.chartBox}>
      <div className={classes.chartBoxHeader}>
        <h4>Market Share by Volume, Labeler</h4>
      </div>
      <div className={classes.chartSubtitle}>
        <span>Click on a company to view their specific sales data</span>
      </div>
      <div className={classes.marketShareList} style={{ maxHeight: '480px', overflowY: 'auto', overflowX: 'hidden' }}>
        {isLoading ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#522d6e', padding: '2rem' }}>
            <div style={{ textAlign: 'center' }}>
              <i className="pi pi-spinner pi-spin" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}></i>
              <p>Loading market share data...</p>
            </div>
          </div>
        ) : marketShareByVolume.length > 0 ? (
          marketShareByVolume.map((item, idx) => (
            <div
              key={idx}
              className={`${classes.shareItem} ${selectedCompany === item.vendor ? classes.selected : ''}`}
              onClick={() => onCompanyClick(item.vendor)}
              style={{ cursor: 'pointer' }}
            >
              <span className={classes.vendorName}>{item.vendor}</span>
              {item.share > 0 ? (
                <div className={classes.shareBarContainer}>
                  <div className={classes.shareBar}>
                    <div
                      className={classes.shareFill}
                      style={{
                        width: `${item.share}%`,
                        background: getBarColor(idx),
                        position: 'relative',
                        minWidth: item.share < 8 ? '60px' : 'auto',
                      }}
                    >
                      <span
                        className={classes.sharePercentage}
                        style={{
                          position: 'absolute',
                          left: '50%',
                          top: '50%',
                          transform: 'translate(-50%, -50%)',
                          color: item.share > 5 ? '#ffffff' : '#1f2937',
                          fontWeight: 700,
                          fontSize: '0.875rem',
                          textShadow: item.share > 5 ? '0 1px 3px rgba(0,0,0,0.5)' : '0 1px 2px rgba(255,255,255,0.8)',
                          whiteSpace: 'nowrap',
                          zIndex: 2,
                        }}
                      >
                        {item.share.toFixed(2)}%
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>0.00%</span>
              )}
            </div>
          ))
        ) : (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
            <i className="pi pi-chart-bar" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}></i>
            <p>No market share data available. Please validate NDC to load chart data.</p>
          </div>
        )}
      </div>
    </div>
  );
};

